import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import translate from '@i18n'

import Loader from '../Loader'
import { AnswerType, QuestionType, SourceType } from '../types'
import AnswerContent from './AnswerContent'
import QuestionMessage from './AnswerHeader'

import type { FunctionComponent } from 'react'

type AnswersMessageProps = {
  answer?: AnswerType
  question: QuestionType
  answerIsLoading: boolean
  answerHasError?: boolean
  onExpandClick: () => void
  onSourcesClick: () => void
  onSourceLinkClick: (linkItem: SourceType) => void
}

const ErrorMessage = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          medium2: { bundledCSS: medium2BodycopyCSS },
        },
      },
    },
  }) => css`
    ${medium2BodycopyCSS};
  `}
`

const StyledAnswersMessage = styled.div`
  display: flex;
  flex-direction: column;

  min-height: 172px;

  ${mobileCSS(css`
    min-height: 226px;
  `)}
`

const AnswerMessage: FunctionComponent<AnswersMessageProps> = ({
  answer,
  question,
  answerIsLoading,
  answerHasError,
  onExpandClick,
  onSourcesClick,
  onSourceLinkClick,
}) => {
  const errorOrNoAnswerMessage = answer?.noAnswer
    ? translate('aiSearch.answer.noAnswerMessage')
    : answerHasError
      ? translate('aiSearch.answer.errorMessage')
      : null

  return (
    <StyledAnswersMessage>
      <QuestionMessage title={question?.text} isLoading={answerIsLoading} />
      {errorOrNoAnswerMessage ? (
        <ErrorMessage>{errorOrNoAnswerMessage}</ErrorMessage>
      ) : answerIsLoading ? (
        <Loader />
      ) : answer ? (
        <AnswerContent
          answer={answer}
          onExpandClick={onExpandClick}
          onSourceLinkClick={onSourceLinkClick}
          onSourcesClick={onSourcesClick}
        />
      ) : null}
    </StyledAnswersMessage>
  )
}

export default AnswerMessage
